import { environment } from 'routes/environment.router';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { CustomFieldService } from '../services/custom-field.service';
import { CustomFieldResponse } from '../services/responses/custom-field.response';

/// Os campos personalizados, ativos e arquivados, carregados uma vez por tela.
export const useCustomFields = () => {
    const [fields, setFields] = useState<CustomFieldResponse[]>([]);
    const service = useMemo(() => new CustomFieldService(), []);

    const fetchAll = useCallback(async () => {
        if (!environment.features.customFields) return;

        try {
            const res = await service.getList();

            setFields(res.data.data ?? []);
        } catch (e) {
            console.error(e);
        }
    }, [service]);

    useEffect(() => {
        fetchAll();
    }, [fetchAll]);

    return { fields, refetch: fetchAll };
};
